import { createFileRoute } from '@tanstack/react-router';
import { TicketsPage } from '@pages/events';

/** Route für die Tickets-Seite (/tickets). */
export const Route = createFileRoute('/tickets/')({ component: TicketsPage });
